import { useQuery } from '@tanstack/react-query';

import type { RiskBandSetQuery } from 'api/RiskBandsApi';
import { RiskBandsApi } from 'api/RiskBandsApi';
import { RISK_BANDS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRiskBandSets(query?: RiskBandSetQuery) {
  const riskBandsApi = new RiskBandsApi();
  const { userBankId } = useUser();

  const { data: riskBandSets, isLoading: isLoadingRiskBandSets } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [RISK_BANDS_KEY, userBankId, query],
    queryFn: () => riskBandsApi.queryRiskBandSets(userBankId, query)
  });

  return { riskBandSets, isLoadingRiskBandSets };
}
